import React, { useEffect, useMemo, useState } from "react";
import DOMPurify from "dompurify";
import Button from "../../components/button";
import Modal from "../../components/modal";
import Headline5 from "../../components/headings/Headline5";
import Styles from "./styles.module.scss";
import classnames from "classnames";
import crownIcon from "../../assets/images/crown_gray_icon.svg";
import workIcon from "../../assets/images/company_icon.svg";
import priceIcon from "../../assets/images/dollar_icon.svg";
import { FormInput } from "../../wrappers/formInput";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { DropDownInput } from "../../wrappers/selectInput";
import { FormAreaInput } from "../../wrappers/formArea";
import { MultiDropDownInput } from "../../wrappers/multiselectInput";
import { getJobDetails, listUserDetailsForCustomer, getEmailBodyHTML } from "./services";
import Toggle from "../../components/toggleButton";
import { inWords } from '../../utils/EllowUtils';
import { Auth } from "aws-amplify";
import { useNavigate } from "react-router-dom";
export type SubmitResourcesFormFields = {
  ellowrate: string;
  billingType: string;
  currencyType: string;
  resourceComments: string;
  subjectLine: string;
  emailBody: string;
  ccEmail: string[];
  bccEmail: string[];
  toEmail: string;
  ellowRateInEmail: boolean;
};

interface Props {
  defaultValues: any;
  ClickHandler: any;
  onClose: any;
  jobId: string;
  rateInMail?: boolean;
  type?: string;
  crRecruiter?: boolean
}

const validationSchema = Yup.object({
  ellowrate: Yup.string().required('Field is required'),
  billingType: Yup.string().required('Field is required'),
  currencyType: Yup.string().required('Field is required'),
  // toEmail: Yup.string().required('Field is required')
});



const SubmitResources: React.FC<Props> = ({
  ClickHandler,
  onClose,
  defaultValues,
  jobId,
  rateInMail,
  type,
  crRecruiter
}) => {
  const formOptions = {
    resolver: yupResolver(validationSchema),
    defaultValues: useMemo(() => {
      return defaultValues;
    }, [defaultValues]),
  };
  let navigate = useNavigate();

  const { register, handleSubmit, control, reset, setValue, formState } =
    useForm<SubmitResourcesFormFields>(formOptions);

  const [payValue, setPayValue] = useState<string>('')

  const [companyMail, setCompanyMail] = useState<string>('')
  const [billingType, setBillingType] = useState<string>('')
  const [currencyType, setCurrencyType] = useState<string>('')
  const [mailSubject, setMailSubject] = useState<string>('')
  const [htmlbody, setHtmlBody] = useState<string>('')

  const [defaultCandidates, setDefaultCandidates] = useState<SubmitResourcesFormFields>({
    ellowrate: '', billingType: '', currencyType: '', resourceComments: '', subjectLine: '', emailBody: '', ccEmail: [], bccEmail: [], toEmail: companyMail, ellowRateInEmail: false
  })
  const [candidatesValue, setCandidatesValue] = useState<any>();
  let resourceLength = defaultValues && defaultValues.length;
  const [step, setStep] = useState<number>(0);
  const [finalData, setFinalData] = useState<Array<any>>([]);
  const [jobData, setJobData] = useState<any>()
  const [email, setEmail] = useState<string>()
  const [rateInEmail, setRateInEmail] = useState<boolean>(false)
  const [ellowRateWarning, setEllowRateWarning] = useState<string>('')
  const [rateInWords, setRateInWords] = useState<string>()
  const [userlist, setUserList] = useState<Array<any>>([])

  useEffect(() => {
    // displayUserDetails();

    if (formState.isSubmitSuccessful) {
      reset()
      reset(defaultCandidates);
      setValue('toEmail', companyMail)
      setValue('billingType', billingType)
      setValue('currencyType', currencyType)
      setValue('ellowRateInEmail', rateInEmail)
    }
    
  }, [formState]);

  const userLoginId = localStorage.getItem('loginId');
  useEffect(() => {

    getJobData(jobId)
    if (type === 'positions') {
      if (defaultValues) { 
        setCandidatesValue(defaultValues);
      }
    }
    if (rateInMail) {
      setValue('ellowRateInEmail', rateInMail)
      setRateInEmail(rateInMail)
    }
  }, []);

  const getJobData = (jobId: string) => {

    getJobDetails(jobId).then(((resp: any) => {

      if (resp && resp.status === 1) {

        setJobData(resp.data[0])
        setValue('toEmail', resp.data[0].companyEmail)
        setCompanyMail(resp.data[0].companyEmail)
        // setValue('billingType', resp.data[0].job_metadata.billingType)
        // setValue('currencyType', resp.data[0].job_metadata.currencyType)
        setBillingType(resp.data[0].job_metadata.billingType)
        setCurrencyType(resp.data[0].job_metadata.currencyType)
        getUsersList(resp.data[0].company_id)
      }
    }))
  }

  const getUsersList = (company_id: string) => {
    listUserDetailsForCustomer(company_id).then((response) => {
      if (response && response.status === 1) {
        response.data.map((item: any) => {
          return (
            userlist.push(item.user_metadata.email)
          )
        })
      }
    })
  }

  //  async function displayUserDetails() { 
  //   Auth.userAttributes(await getCurrentUser())
  //   .then(result => {
  //      let emailindex = result.findIndex((item) => item.Name === 'email');
  //      let loginidindex = result.findIndex((item) => item.Name === 'sub');
  //      let given_name_index = result.findIndex((item) => item.Name === 'given_name');
  //      let family_name_index = result.findIndex((item) => item.Name === 'family_name');

  //      localStorage.setItem('Name', result[given_name_index].Value + ' ' + result[family_name_index].Value)
  //      localStorage.setItem('loginId', result[loginidindex].Value)
  //      localStorage.setItem('Email', result[emailindex].Value) 
  //      })
  //     }

  //     async function getCurrentUser() {
  //       try {
  //         var currentUser = await Auth.currentAuthenticatedUser()
  //         // setGoogleId(currentUser.username)
  //       //  googleId = currentUser.username
  //         return currentUser;
  //       }
  //       catch (err: any) {
  //         navigate(`/login`, {
  //           state: {
  //             error: err,
  //           }
  //       }
  //       );
  //       }
  //     } 


  const convertToApi = (data: any) => {
    
    let convertedData = {
      bccEmail: data.bccEmail,
      ccEmail: data.ccEmail,
      toEmail: [data.toEmail],
      candidateId: candidatesValue[step].loginId,
      candidateJobMetadata: {
        "ellowRate": parseInt(data.ellowrate),
        "billingType": data.billingType,
        "currencyType": data.currencyType,
        "comment": data.resourceComments,
        "ellowRateInEmail": data.ellowRateInEmail ? true : false,
        "resourceRate":  parseInt(candidatesValue[step].rates)
      }
    }  
    return convertedData
  }

  const initSubmit = (data: any) => {

    if (type === 'positions') {
      const newData = convertToApi(data)
      if (step !== resourceLength - 1) {
        setStep(step + 1);
        finalData.push(newData);
      }
    }
    else {
    }

  };

  const onSubmit = (data: any) => {
    if (type === 'positions') {
      finalData.push(convertToApi(data));

      let finalSubmitingData = {
        "jobId": jobId,
        "userLoginId": userLoginId,
        "positionStatus": 1,
        "candidateMetadata": finalData,
        "jobType": jobData.job_metadata.jobType
      }

      ClickHandler(finalSubmitingData)
    }
    else {
      let finalSubmitingData = {
        "jobId": jobId,
        "userLoginId": userLoginId,
        "positionStatus": 1,
        "jobType": jobData.job_metadata.jobType,
        "candidateMetadata": [{
          bccEmail: data.bccEmail,
          ccEmail: data.ccEmail,
          toEmail: [data.toEmail],
          candidateId: defaultValues.loginId,
          candidateJobMetadata: {
            "ellowRate": parseInt(data.ellowrate),
            "billingType": data.billingType,
            "currencyType": data.currencyType,
            "comment": data.resourceComments,
            "ellowRateInEmail": data.ellowRateInEmail ? true : false,
            "resourceRate": parseInt(data.rates ? data.rates : data.resourceRate)
          }
        }]
      }
      ClickHandler(finalSubmitingData)
    }
  };

  const handleChange = (e: any, name: any) => {

    if (name === 'ellowrate') {
      let words = inWords(e.target.value)
      setRateInWords(words)
      setPayValue(e.target.value ? Math.abs(e.target.value).toString() : '')
      setEllowRateWarning("ellow rate should be 20% greater than resource rate")
      setTimeout(() => {
        setEllowRateWarning('')
      }, 5000);
    }
    else if (name === 'ellowRateInEmail') {
      setValue(name, e.value)
      setRateInEmail(e.value)
    }
    else {
      setValue(name, e.target.value)
    }
  };
  const genertorMailContent = (data: any) => {
    
    let finalSubmitingData = {
      "jobId": jobId,
      "userLoginId": userLoginId,
      "type": "applyToPosition",
      "candidateMetadata": [{
        candidateId: defaultValues[0].loginId,
        candidateJobMetadata: {
          "ellowRate": parseInt(data.ellowrate),
          "billingType": data.billingType,
          "currencyType": data.currencyType,
          "comment": data.resourceComments,
          "ellowRateInEmail": data.ellowRateInEmail ? true : false
        }
      }]

    };
    getEmailBodyHTML(finalSubmitingData).then((response: any) => {
      if (response) {

        setMailSubject(response[0].subject)
        setHtmlBody(response[0].htmlBody);
      }
    })

  }
  const createMarkup = (html: any) => {

    return {
      __html: DOMPurify.sanitize(html),
    };


  };
  return (
    <Modal title={" "} onClose={onClose} size="large">
      <form>
        <Headline5>Submit Resources</Headline5>
        <div className={Styles.resourcesWrap}>
          {type === 'positions' ? <div className={Styles.resourcesList}>
            {candidatesValue &&
              candidatesValue.map((item: any, key: number) => {
                return (
                  <div className={step === key ? classnames(Styles.resourcesItem, Styles.active) : Styles.resourcesItem}>
                    <figure>{item.firstName[0]}{item.lastName[0]}</figure>
                    <figcaption>{item.name}</figcaption>
                  </div>)
              })}
          </div> :
            <div className={Styles.resourcesList}>

              <div className={classnames(Styles.resourcesItem, Styles.active)}>
                <figure>{jobData && jobData.job_metadata && jobData.job_metadata.title && jobData.job_metadata.title[0]}</figure>
                <figcaption>{jobData && jobData.job_metadata && jobData.job_metadata.title}</figcaption>
              </div>

            </div>
          }

          <div className={Styles.resourcesDetails}>

            {type === 'positions' ? <div className={Styles.resourcesItem}>
              <figure> {candidatesValue && candidatesValue[step] && candidatesValue[step].firstName[0]}{candidatesValue && candidatesValue[step] && candidatesValue[step].lastName[0]}</figure>
              <figcaption>
                {candidatesValue && candidatesValue[step] && candidatesValue[step].name}<span>
                  {
                    candidatesValue && candidatesValue[step] && candidatesValue[step].skills && candidatesValue[step].skills.toString()
                  }
                </span>
              </figcaption>
            </div>
              :
              <div className={Styles.resourcesItem}>
                <figure>{jobData && jobData.job_metadata && jobData.job_metadata.title && jobData.job_metadata.title[0]}</figure>
                <figcaption>
                  {jobData && jobData.job_metadata && jobData.job_metadata.title}<span>
                    {
                      jobData && jobData.job_metadata && jobData.job_metadata.coreSkills && jobData.job_metadata.coreSkills.map((item: any) => {
                        return (
                          item.skillName
                        )
                      })
                    }
                  </span>
                </figcaption>
              </div>
            }
            <div className={Styles.resourcesProfile}>
              <div className={Styles.profileItem}>
                <figure>
                  <img src={workIcon} />
                </figure>
                <div>
                  <label>Company Name</label>
                  <h3>{jobData && jobData.companyName}</h3>
                </div>
              </div>
              <div className={Styles.profileItem}>
                <figure>
                  <img src={crownIcon} />
                </figure>
                <div>
                  <label>Work Experience</label>
                  {/* <h3>{ jobData && jobData.job_metadata && jobData.job_metadata.experienceRange} Years</h3> */}
                  <h3>{jobData && jobData.job_metadata && jobData.job_metadata.experienceRange ? jobData.job_metadata.experienceRange.min + " - " + jobData.job_metadata.experienceRange.max + ' Years' : 'Not Mentioned'}</h3>

                </div>
              </div>
              <div className={Styles.profileItem}>
                <figure>
                  <img src={priceIcon} />
                </figure>
                <div>
                  <label>Resource Rate</label>
                  {type === 'positions' && 
                    <h3> {candidatesValue && candidatesValue[step].rates ? candidatesValue[step].rates + ' ' + candidatesValue[step].currencyType + '/' + candidatesValue[step].billingType : 'Not mentioned'} </h3>
                  }
                  {type === 'resources' && 
                    <h3> {defaultValues && defaultValues.rates ? defaultValues.rates + ' ' + defaultValues.currencyType + '/' + defaultValues.billingType  : defaultValues.resourceRate ? defaultValues.resourceRate + ' ' + defaultValues.currencyType + '/' + defaultValues.billingType : 'Not mentioned'}  </h3>
                  }
                </div>
              </div>
            </div>
            <br></br>
            <div className="form-group mb-4">
              <div className={classnames("lablel", Styles.candidateWrap)}>Show ellow rate in the mail
                <Toggle
                  onChange={(e: any) => handleChange(e, 'ellowRateInEmail')}
                  defaultChecked={rateInMail}
                /> </div>
              <label className="lablel"> Ellow rate will be included in the emails received from ellow.io</label>
            </div> <br></br>

            <div className="one-third-form-wrap small-gap">
              <div className="form-group">
                <label className="lablel">ellow rate*</label>
                <FormInput<SubmitResourcesFormFields>
                  name="ellowrate"
                  placeholder="ellow rate"
                  type="number"
                  register={register}
                  value={payValue}
                  // errors={formState.errors}
                  onchange={(e: any) => handleChange(e, 'ellowrate')}
                />
              </div>
              <div className="form-group">
                <label className="lablel">Currency Type*</label>
                <DropDownInput<SubmitResourcesFormFields>
                  data={["INR", "USD"]}
                  name="currencyType"
                  control={control}
                  register={register}
                  // errors={formState.errors}
                  // defaultValue={jobData && jobData.job_metadata && jobData.job_metadata.currencyType}

                />
              </div>
              <div className="form-group">
                <label className="lablel">Time basis*</label>
                <DropDownInput<SubmitResourcesFormFields>
                  data={["Hourly", "Daily", "Monthly"]}
                  name="billingType"
                  control={control}
                  register={register}
                  // defaultValue={jobData && jobData.job_metadata && jobData.job_metadata.billingType}
                // errors={formState.errors}
                />
              </div>
            </div>
            {rateInWords}
            <p style={{ 'color': 'red', 'fontSize': '12px' }}>{ellowRateWarning}</p>
            <br></br>
            <br></br>
            <div className="form-group mb-4">
              <FormAreaInput<SubmitResourcesFormFields>
                name="resourceComments"
                placeholder="Comment about resource"
                type="text"
                register={register}
                onchange={(e: any) => handleChange(e, 'resourceComments')}
                // errors={formState.errors}
                value=''
              ></FormAreaInput>
            </div>
            <div className={Styles.generatebtn}>
              <Button
                onClick={handleSubmit(genertorMailContent)}
                type="submit"
                variant="primary"
                size="small"
              >
                Preview mail
              </Button>
            </div>
            <br>
            </br>
            {/* <div className="form-group">
              <FormInput<SubmitResourcesFormFields>
                name="subjectLine"
                type="text"
                register={register}
                // errors={formState.errors}
                placeholder="Subject Line"
                value={mailSubject}
              />
            </div> */}
            <div className="form-group">
              {htmlbody ? (
                <div
                  className="preview"
                  dangerouslySetInnerHTML={
                    createMarkup(htmlbody)
                  }
                ></div>
              ) : (
                <div></div>
              )
              }
            </div>
            {/* <FormAreaInput<SubmitResourcesFormFields>
                  name="emailBody"
                  placeholder="Email body"
                  register={register}
                  onchange={(e: any) => handleChange(e, 'emailBody')}
                  // errors={formState.errors}
                  value={htmlbody}
                ></FormAreaInput> */}
            <div className="form-group mb-4">
              <DropDownInput<SubmitResourcesFormFields>
                data={userlist}
                name="toEmail"
                control={control}
                register={register}
                // errors={formState.errors}
                defaultValue={companyMail}
              />
            </div>
            <div className="form-group">
              <label className="lablel">
                Do you want to include other users in the email loop?
              </label>
            </div>
            <div className="form-group">
              {/* <Fields placeholder="Cc" /> */}
              <MultiDropDownInput<SubmitResourcesFormFields>
                name="ccEmail"
                data={[]}
                control={control}
                placeholder="Cc"
                register={register}
                // errors={formState.errors}
                onChange={(e: any) => handleChange(e, "ccEmail")}
              />
            </div>
            <div className="form-group">
              {/* <Fields placeholder="Bcc" /> */}
              <MultiDropDownInput<SubmitResourcesFormFields>
                name="bccEmail"
                data={[]}
                control={control}
                placeholder="Bcc"
                register={register}
              // errors={formState.errors}
              />
            </div>
          </div>
        </div>
        <div className="popupAction">
          <Button
            onClick={onClose}
            type="submit"
            variant="secondary"
            size="small"
          >
            Cancel
          </Button>
          <Button
            onClick={
              step < resourceLength - 1
                ? handleSubmit(initSubmit)
                : handleSubmit(onSubmit)
            }
            type="submit"
            variant="primary"
            size="small"
          >
            {step < resourceLength - 1 ? "Next" : "Finish"}
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default SubmitResources;
